<template>
  <el-dialog
    title="制作卤药"
    :visible.sync="dialogVisible"
    width="600px"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="true"
    @opened="onDialogOpened"
    @close="onDialogClose"
  >
    <div class="luyao-make-dialog" @keydown.esc="onCancel">
      <!-- 品种选择表格 -->
      <div class="product-table-section">
        <label class="section-label">选择卤药品种：</label>
        <el-table
          ref="productTable"
          :data="productList"
          height="200"
          highlight-current-row
          @current-change="onCurrentRowChange"
          @row-dblclick="onRowDoubleClick"
          @keydown.native.enter="onTableEnter"
          @keydown.native.up="onTableArrowUp"
          @keydown.native.down="onTableArrowDown"
          tabindex="0"
          class="product-table"
        >
          <el-table-column prop="bgmName" label="品种名称" min-width="150">
            <template slot-scope="scope">
              <span :class="{ 'selected-product': scope.row === selectedProduct }">
                {{ scope.row.bgmName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="bgmCode" label="编码" width="150">
            <template slot-scope="scope">
              {{ scope.row.bgmCode || '-' }}
            </template>
          </el-table-column>
        </el-table>
        <div class="table-tip">
          <i class="el-icon-info"></i>
          <span>上下键切换，双击或按回车键选择品种</span>
        </div>
      </div>

      <!-- 数量输入 -->
      <div class="form-row">
        <label class="form-label">制作数量：</label>
        <el-input
          v-model="quantity"
          :min="1"
          :max="9999"
          :precision="0"
          type="number"
          :step="1"
          placeholder="请输入数量"
          style="width: 200px"
          class="quantity-input"
          @keydown.native.enter="onQuantityEnter"
        />
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="onCancel">取 消</el-button>
      <el-button type="primary" @click="onConfirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'LuyaoMakeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    productList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedProduct: null,
      quantity: 1,
      currentRow: null
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    canConfirm() {
      return this.selectedProduct && this.quantity > 0 && Math.abs(this.quantity) <= (this.selectedProduct.num || 0)
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.resetForm()
      }
    }
  },
  methods: {
    resetForm() {
      this.selectedProduct = null
      this.quantity =     1
      this.currentRow = null
      if (this.$refs.productTable) {
        this.$refs.productTable.setCurrentRow()
      }
    },
    onProductChange() {
      // 商品变更时重置数量
      this.quantity = 1
    },
    // 表格当前行变化
    onCurrentRowChange(currentRow) {
      this.currentRow = currentRow
      this.selectedProduct = currentRow // 同时更新选中的商品
    },
    // 双击行选择商品
    onRowDoubleClick(row) {
      this.selectProduct(row)
    },
    // 回车键选择商品
    onTableEnter(event) {
      if (this.currentRow) {
        this.selectProduct(this.currentRow)
        event.preventDefault()
      }
    },
    // 上箭头键处理
    onTableArrowUp(event) {
      event.preventDefault()
      if (this.productList.length === 0) return
      
      const currentIndex = this.productList.findIndex(item => item === this.currentRow)
      let newIndex = currentIndex - 1
      
      // 如果到达顶部，循环到底部
      if (newIndex < 0) {
        newIndex = this.productList.length - 1
      }
      
      const newRow = this.productList[newIndex]
      this.$refs.productTable.setCurrentRow(newRow)
      this.currentRow = newRow
    },
    // 下箭头键处理
    onTableArrowDown(event) {
      event.preventDefault()
      if (this.productList.length === 0) return
      
      const currentIndex = this.productList.findIndex(item => item === this.currentRow)
      let newIndex = currentIndex + 1
      
      // 如果到达底部，循环到顶部
      if (newIndex >= this.productList.length) {
        newIndex = 0
      }
      
      const newRow = this.productList[newIndex]
      this.$refs.productTable.setCurrentRow(newRow)
      this.currentRow = newRow
    },
    // 选择商品
    selectProduct(product) {
      this.selectedProduct = product
      this.quantity = 1
      // 聚焦到数量输入框
      this.$nextTick(() => {
        const quantityInput = this.$el.querySelector('.quantity-input input')
        if (quantityInput) {
          quantityInput.focus()
          quantityInput.select()
        }
      })
    },
    // 数量输入框回车事件
    onQuantityEnter() {
         this.onConfirm()
    },
    // 弹窗打开后聚焦到表格
    focusTable() {
      this.$nextTick(() => {
        if (this.$refs.productTable) {
          this.$refs.productTable.$el.focus()
          // 如果有数据，默认选中第一行
          if (this.productList.length > 0) {
            this.$refs.productTable.setCurrentRow(this.productList[0])
            this.currentRow = this.productList[0]
            this.selectedProduct = this.productList[0] // 同时设置选中的商品
          }
        }
      })
    },
    onDialogOpened() {
      this.$emit('opened')
      // 聚焦到表格
      this.focusTable()
    },
    onDialogClose() {
      this.$emit('close')
    },
    onCancel() {
      this.dialogVisible = false
    },
    onConfirm() {
      if (!this.canConfirm) {
        if (!this.selectedProduct) {
          this.$message.warning('请选择卤药品种')
          return
        }
        if (this.quantity <= 0) {
          this.$message.warning('请输入正数数量')
          return
        }
      }

      const makeData = {
        product: this.selectedProduct,
        quantity: Number(-this.quantity)
      }

      this.$emit('confirm', makeData)
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.luyao-make-dialog {
  padding: 10px 0;
}

.product-table-section {
  margin-bottom: 20px;
}

.section-label {
  display: block;
  margin-bottom: 10px;
  font-weight: bold;
  color: #333;
  font-size: 14px;
}

.product-table {
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.product-table:focus {
  outline: 2px solid #409eff;
  outline-offset: 2px;
}

.selected-product {
  font-weight: bold;
  color: #409eff;
}

.low-stock {
  color: #f56c6c;
  font-weight: bold;
}

.table-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
  display: flex;
  align-items: center;
}

.table-tip i {
  margin-right: 4px;
}

.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.form-label {
  width: 100px;
  text-align: right;
  margin-right: 15px;
  font-weight: bold;
  color: #333;
}

.quantity-tip {
  margin-left: 10px;
  color: #909399;
  font-size: 12px;
}

.product-info {
  background-color: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
  margin: 20px 0;
}

.info-row {
  display: flex;
  margin-bottom: 8px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-label {
  width: 80px;
  color: #606266;
  font-size: 14px;
}

.info-value {
  color: #303133;
  font-weight: 500;
}

.make-note {
  margin: 20px 0;
}

.make-note .el-alert {
  background-color: #f0f9ff;
  border-color: #b3d8ff;
}

.make-note p {
  margin: 5px 0;
  font-size: 13px;
}

.dialog-footer {
  text-align: right;
}
</style>
